<div class="layout-col full">
  <elder-table class="flex" [selectionVisible]="false" [data]="data$ | async" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 20%">
        {{ 'context.material' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <span>{{ item.material?.searchTerm }}</span
        ><br />
        <small>{{ item.materialId }}</small>
      </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>{{ 'context.quantity' | translate }}</th>
      <td mat-cell *matCellDef="let item; let i = index">
        <div class="layout-row place-start-center gap-md">
          <mat-form-field
            [floatLabel]="'always'"
            [subscriptSizing]="'dynamic'"
            style="width: 50px; text-align: right"
          >
            <input
              matInput
              type="number"
              elderNoSpinner
              name="quantity+{{ i }}"
              #quantity="ngModel"
              [min]="minQuantity"
              [max]="maxQuantity"
              [(ngModel)]="item.quantity"
              (ngModelChange)="onRecordChange(item)"
            />

            @if (quantity.errors?.['min'] || quantity.errors?.['max']) {
              <mat-error> Must be >= {{ minQuantity }} and <= {{ maxQuantity }} </mat-error>
            }
          </mat-form-field>

          <div>
            <button mat-icon-button (click)="onDecrement(item)">
              <mat-icon>remove</mat-icon>
            </button>
            <button mat-icon-button (click)="onIncrement(item)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>
  </elder-table>
</div>
